import React from 'react'
import { PALETTE } from '../../styles/constants'

function SearchIcon({ color = PALETTE.gray80 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_2421_4891)">
        <path d="M21.7502 20.6894L16.0861 15.0254C17.4471 13.3914 18.1258 11.2956 17.981 9.17394C17.8362 7.05231 16.8789 5.06819 15.3085 3.63433C13.738 2.20047 11.6752 1.42728 9.54918 1.47559C7.42316 1.5239 5.39761 2.39 3.89389 3.89372C2.39018 5.39743 1.52408 7.42298 1.47577 9.54901C1.42746 11.675 2.20065 13.7378 3.63451 15.3083C5.06836 16.8788 7.05248 17.836 9.17412 17.9808C11.2958 18.1257 13.3915 17.447 15.0255 16.0859L20.6896 21.75L21.7502 20.6894ZM3.00018 9.75C3.00018 8.41498 3.39606 7.10993 4.13776 5.9999C4.87946 4.88987 5.93366 4.02471 7.16706 3.51382C8.40047 3.00292 9.75766 2.86925 11.067 3.1297C12.3764 3.39015 13.5791 4.03303 14.5231 4.97703C15.4672 5.92104 16.11 7.12377 16.3705 8.43314C16.6309 9.74251 16.4973 11.0997 15.9864 12.3331C15.4755 13.5665 14.6103 14.6207 13.5003 15.3624C12.3902 16.1041 11.0852 16.5 9.75018 16.5C7.96058 16.498 6.24484 15.7862 4.9794 14.5208C3.71396 13.2553 3.00216 11.5396 3.00018 9.75Z" fill={color}/>
      </g>
      <defs>
        <clipPath id="clip0_2421_4891">
          <rect width="24" height="24" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}

export default SearchIcon


